import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { theme } from "./chakra/theme";
import ColorModeSync from "./chakra/ColorModeSync";
import MuiBridge from "./chakra/MuiBridge";

// keep your global CSS, and import theme-fixed.css LAST
import "./style.css";
import "./index.css";
import "./theme-fixed.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ColorModeSync />
      <MuiBridge>
        <App />
      </MuiBridge>
    </ChakraProvider>
  </React.StrictMode>
);
